import cx from 'classnames';
import { Field, Formik } from 'formik';
import { useContext, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as Yup from 'yup';

import { OnboardingContext } from '../../context/OnboardingContext';
import LoopSpinner from '../../ui/LoopSpinner';
import InfoModal from '../../ui/Modal/InfoModal';
import { RadioWrapper } from '../../ui/Styled';
import { min } from '../../utils/breakpoints';

import SmartTariffInfoContent from './SmartTariffInfoContent';

const StyledFormContainer = styled.div`
  margin-top: 2rem;
  text-align: left;

  ${min.sm} {
    margin-top: 3rem;
  }
`;

const SmartTariffContainer = () => {
  const navigate = useNavigate();
  const { setProgressPercentage, setHasSmartTariff } = useContext(OnboardingContext);
  const [showInfoModal, setShowInfoModal] = useState(false);

  const validationSchema = Yup.object().shape({
    smartTariff: Yup.string().required('Please choose if you have a smart tariff'),
  });

  const onSubmit = (values) => {
    if (values?.smartTariff === 'yes') {
      setHasSmartTariff('yes');
      navigate('/onboarding/tariff');
    } else {
      setHasSmartTariff('no');
      navigate('/onboarding/smart-tariff-warning');
    }
  };

  useEffect(() => {
    setProgressPercentage(15);
  }, []);

  return (
    <>
      <h1 className="mb-3">
        Are you on a<br />
        smart tariff?
      </h1>

      <div>
        <p>
          A smart tariff is one that can change up to every half hour during the day. There are typically import and
          export smart tariffs that pair together.
        </p>
        <p>
          If you're unsure which tariff you have, select "No, I'm not on a smart tariff", and you can change it in
          Settings later.
        </p>
        <div className="btn-link" type="button" onClick={() => setShowInfoModal(true)}>
          More info about smart tariffs
        </div>
        <StyledFormContainer>
          <Formik
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            initialValues={{ smartTariff: '' }}
            validateOnChange
            validateOnMount
          >
            {({ handleSubmit, isValid, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                <Field name="smartTariff">
                  {({ field, meta }) => (
                    <>
                      <RadioWrapper
                        className={cx({
                          selected: field.value === 'yes',
                        })}
                      >
                        <Form.Check
                          {...field}
                          type="radio"
                          id="smart-tariff-yes"
                          value="yes"
                          label="Yes, I have a smart tariff"
                        />
                      </RadioWrapper>
                      <RadioWrapper
                        className={cx({
                          selected: field.value === 'no',
                        })}
                      >
                        <Form.Check
                          {...field}
                          type="radio"
                          id="smart-tariff-no"
                          value="no"
                          label="No, I'm not on a smart tariff"
                        />
                      </RadioWrapper>
                    </>
                  )}
                </Field>

                <Form.Group>
                  {!isSubmitting ? (
                    <Button variant="primary" disabled={!isValid || isSubmitting} className="w-100" type="submit">
                      Continue
                    </Button>
                  ) : (
                    <LoopSpinner />
                  )}
                </Form.Group>
              </Form>
            )}
          </Formik>
        </StyledFormContainer>
      </div>

      <InfoModal
        size="lg"
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        infoContent={<SmartTariffInfoContent />}
      />
    </>
  );
};

export default SmartTariffContainer;
